export default __webpack_public_path__ + "21aec04fb52bb0b1e989cdbb5a32e068.svg";